import { createRoot } from "react-dom/client";
import { App } from "./App";

const ACCESS_CODE = "4b87312c-33f8-49b4-8679-340779b44086";

function start() {
  const root = createRoot(document.getElementById("root")!);
  if (validateAccessCode()) {
    root.render(<App />);
  } else {
    NoAccess();
  }
}

function NoAccess() {
  const root = document.getElementById("root");
  root!.innerHTML = "<h1 class='text-center mt-20 text-2xl'>No Access. Sorry this site is for Guests only. Thank You</h1>";
}

function getAccessCodeFromURL() {
  const params = new URLSearchParams(window.location.search);
  return params.get("access");
}

function setLocalStorageAccess() {
  window.localStorage.setItem("access_granted", "true");
}

function getLocalStorageAccess() {
  return window.localStorage.getItem("access_granted") === "true";
}

function validateAccessCode() {
  const accessCode = getAccessCodeFromURL();
  if (accessCode === ACCESS_CODE) {
    setLocalStorageAccess();
    return true
  }
  if (getLocalStorageAccess()) return true;
  return false;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
